import { Text, View } from "@react-pdf/renderer";
import TaxGuideStyles from "./TaxGuideStyles";

const Footer = ({ primaryColor, regulatoryText }) => {
  const styles = TaxGuideStyles(primaryColor || "081e56");
  return (
    <View style={styles.footer} fixed>
      {/* <Text style={styles.pageFooterText}>{regulatoryText || ""} </Text> */}
    </View>
  );
};

export default Footer;
